import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

import ENV from 'umg-ember-backend/config/environment';
import { modelIconAssetPath } from 'umg-ember-backend/helpers/model-icon';

export default class HeadDataService extends Service {
  // Defaults
  @tracked _title = '';
  @tracked _favicon = 'dashboard';
  siteName = 'Universal Music Group';

  // Getter and setter
  get enviromentIcon() {
    let isDevelopment = ENV.environment === 'development';
    let enviroments = {
      'https://stage.rest.universal-music.de': 'stage',
      'https://approval.rest.universal-music.de': 'approval',
      'https://rest.universal-music.de': 'production',
    };
    let enviroment = isDevelopment ? 'development' : enviroments[ENV.API.host];
    let enviromentIcon = {
      approval: '👷 ',
      stage: '👷‍♀️ ',
      development: '🚧 ',
      production: '',
    };

    return enviromentIcon[enviroment];
  }

  get favicon() {
    return `${modelIconAssetPath([this._favicon])}?v=3`;
  }

  set favicon(value) {
    this._favicon = value;
  }

  get title() {
    let segments = [this.siteName];

    if (this._title || this.enviromentIcon) {
      segments.unshift(`${this.enviromentIcon}${this._title}`);
    }

    return segments.join(' — ');
  }

  set title(value) {
    this._title = value;
  }
}
